<tecneplas-toasts aria-live="polite" aria-atomic="true"></tecneplas-toasts>

<main role="main">
    <div class="container-fluid p-0">
        <router-outlet></router-outlet>
    </div>
</main>